import ActTeamManangement from './ActTeamManagement';

export default ActTeamManangement;
